/**
 * Liên kết Zalo Mini App ↔ phòng khám. Real /api/v1/clinic/settings/zalo-miniapp.
 *
 * The row this writes (`zalo_app_binding`) is what lets the backend resolve a tenant from a Mini
 * App id BEFORE any login happens. Until it exists, the Mini App answers every patient login with
 * `zalo_app_not_bound` ("Ứng dụng Zalo chưa được liên kết với phòng khám nào.").
 *
 * ONE binding per clinic, the same shape as the website. A per-brand variant was built for #18687
 * and removed: the Mini App reads its content from Addy Sites keyed on the clinic slug, so a second
 * brand's app served identical content — it configured a difference that did not exist.
 */
import { apiClient } from "./client";

export interface ZaloMiniAppBinding {
  linked: boolean;
  zaloAppId: string | null;
  oaId: string | null;
  enabled: boolean;
  updatedAt: string | null;
}

export interface ZaloMiniAppBindingUpdate {
  zaloAppId: string;
  oaId: string | null;
  enabled: boolean;
}

export const zaloMiniAppApi = {
  get(): Promise<ZaloMiniAppBinding> {
    return apiClient
      .get<ZaloMiniAppBinding>("/v1/clinic/settings/zalo-miniapp")
      .then((r) => r.data);
  },
  update(body: ZaloMiniAppBindingUpdate): Promise<ZaloMiniAppBinding> {
    return apiClient
      .put<ZaloMiniAppBinding>("/v1/clinic/settings/zalo-miniapp", body)
      .then((r) => r.data);
  },
  unlink(): Promise<ZaloMiniAppBinding> {
    return apiClient
      .delete<ZaloMiniAppBinding>("/v1/clinic/settings/zalo-miniapp")
      .then((r) => r.data);
  },
};

export const zaloMiniAppQueryKeys = {
  all: () => ["clinic-zalo-miniapp"] as const,
};
